import {
  RpcRequestError,
  HttpRequestError,
  TimeoutError,
  TransactionExecutionError,
  ContractFunctionExecutionError,
} from 'viem';

// Utility function to handle viem errors
export const handleViemError = (
  err: unknown,
): { shouldShowRpcModal: boolean; errorMessage: string } => {
  // Check for specific viem error types
  if (err instanceof RpcRequestError) {
    // Extract the core error message from RPC error details
    const coreMessage =
      (err as any).error?.message || err.details || err.message || 'RPC request failed';
    return {
      shouldShowRpcModal: true,
      errorMessage: coreMessage,
    };
  }

  if (err instanceof HttpRequestError) {
    return {
      shouldShowRpcModal: true,
      errorMessage: err.details || err.message || 'HTTP request failed',
    };
  }

  if (err instanceof TimeoutError) {
    return {
      shouldShowRpcModal: true,
      errorMessage: 'Request timeout - please try again',
    };
  }

  if (err instanceof TransactionExecutionError || err instanceof ContractFunctionExecutionError) {
    return {
      shouldShowRpcModal: false, // Contract errors are user errors, not RPC issues
      errorMessage: err.shortMessage || err.message || 'Transaction failed',
    };
  }

  // Enhanced error message extraction for any object with error-like properties
  let errorMessage = 'Unknown error occurred';

  if (err && typeof err === 'object') {
    const errorObj = err as any;
    // Try to extract message in order of preference: shortMessage, message, reason
    errorMessage = errorObj.shortMessage || errorObj.message || errorObj.reason || errorMessage;
  } else if (err instanceof Error) {
    errorMessage = err.message;
  } else if (typeof err === 'string') {
    errorMessage = err;
  } else {
    errorMessage = String(err);
  }
  // Determine if should show RPC modal based on message content
  const normalizedErrorMessage = errorMessage.toLowerCase();
  const shouldShowRpcModal =
    normalizedErrorMessage.includes('rpc') ||
    normalizedErrorMessage.includes('network') ||
    normalizedErrorMessage.includes('timeout');

  return {
    shouldShowRpcModal,
    errorMessage,
  };
};
